import { Skeleton } from '@mui/material';
import 'app/agriculture/components/Title/Title.scss';
import { LogoIcon } from 'app/agriculture/icons';

export function TitleSkeleton() {
    return (
        <div className="Title">
            <LogoIcon className="Title__logo" size={24} />
            <h1 className="Title__text">
                <Skeleton width={200} />
            </h1>
        </div>
    );
}
